<template>
  <div class="title">
      {{ title }}
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>

</style>

<style scoped>
.title {
  font-size: 18px;
  font-weight: 700;
  font-family: Lato;
  color: #223448;
}
</style>
